import { render, staticRenderFns } from "./TransactionDetail.vue?vue&type=template&id=762d06f6&scoped=true"
import script from "./TransactionDetail.vue?vue&type=script&lang=js"
export * from "./TransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./TransactionDetail.vue?vue&type=style&index=0&id=762d06f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762d06f6",
  null
  
)

export default component.exports